const pageNaming = pageName => {
  return pageName.split(" ").join("-")
}

export default pageNaming
